import React from 'react'
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from '@/components/ui/tooltip'
import { GoogleSignIn } from './googleSignIn'
import { MicrosoftSignIn } from './microsoftSignIn'
import { Sidebar } from './sidebar'
import evermuseLogo from '@/assets/evermuse-logo-21h.svg'

export function SignIn() {
  return (
    <div className="min-h-screen flex flex-col">
      {/* Primary content area */}
      <div className="flex-1 px-6 py-8">
        <div className="max-w-md mx-auto">
          <div className="mb-16">
            <img src={evermuseLogo} alt="Evermuse" width="170" height="21" className="mx-auto" />
          </div>

          <p className="text-2xl font-bold font-['DM_Sans'] text-zinc text-center mb-2">Automate your user research</p>
          <p className="text-base font-medium font-['DM_Sans'] text-zinc text-center mb-8">
            Record, analyze, document, and categorize user stories from your meetings.
          </p>

          <div className="space-y-4">
            <GoogleSignIn />
            <MicrosoftSignIn />
          </div>

          <div className="mt-6 mb-10">
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <p className="text-slate text-sm font-['Raleway'] underline text-center cursor-pointer">
                    Why does Evermuse require access to my calendar?
                  </p>
                </TooltipTrigger>
                <TooltipContent className="bg-black text-white border-black max-w-[320px] leading-snug">
                  Evermuse converts your customer calls into actionable product suggestions. In order to do that it
                  needs to join your calls with customers. You can always change this later.
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          </div>
        </div>
      </div>

      {/* Sidebar content below */}
      <div className="bg-grey-100 px-6 py-8">
        <Sidebar />
      </div>
    </div>
  )
}
